
<iframe *ngIf="url" [style.height]="innerHeight" id="iframe" style="width: 100%" [src]="url" title="iframe"></iframe>
